import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import supabase from './supabaseClient';
import Login from './Login';
import Register from './Register';
import Dashboard from './Dashboard';
import DealerView from './DealerView';
import DealPage from './DealPage';
import Header from './Header';

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data, error }) => {
      if (error) console.error('Ошибка при получении сессии:', error);
      setSession(data?.session ?? null);
    if (data?.session?.user) localStorage.setItem("user", JSON.stringify(data.session.user));
      setLoading(false);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    if (session?.user) localStorage.setItem("user", JSON.stringify(session.user));
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  if (loading) return <p>Загрузка...</p>;

  return (
    <Router>
      {!session ? (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      ) : (
        <>
          <Header onLogout={() => setSession(null)} />
          <Routes>
            <Route path="/" element={<Dashboard session={session} />} />
            <Route path="/dealer" element={<DealerView />} />
            <Route path="/deal/:id" element={<DealPage />} />
          </Routes>
        </>
      )}
    </Router>
  );
}

export default App;
